import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CurrenciesService } from '@app/shared/services/currencies/currencies.service';
import { DirectService, PromoCode, PromoCodeType } from '../../services/direct.service';

@Component({
  standalone: false,
  templateUrl: './direct-promo-codes-edit.component.html',
  styleUrls: ['./direct-promo-codes-edit.component.scss'],
})
export class DirectPromoCodesEditComponent implements OnInit {
  currencies$ = this.currenciesService.getCurrencies(true);
  overlappingProperties = [];
  promoCode: PromoCode;

  saving: boolean = false;
  recentlySaved: boolean = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private currenciesService: CurrenciesService,
    private direct: DirectService
  ) { }

  ngOnInit(): void {
    this.fetchPromoCode(this.route.snapshot.params.uuid);
  }

  fetchPromoCode(uuid: PromoCode['uuid']) {
    this.direct.getPromoCode(uuid).subscribe((response) => {
      this.promoCode = response;

      this.checkForPropertyRestrictions(this.promoCode);
    });
  }

  checkForPropertyRestrictions(promoCode: PromoCode) {
    this.direct.promoCodeCheckPropertyRestrictions(promoCode).subscribe((res) => {
      this.overlappingProperties = res;
    });
  }

  goBack() {
    this.router.navigate(['/direct/promotions']);
  }

  saveCode() {
    const { currency, ...withoutCurrency } = this.promoCode;
    const promoCode = this.promoCode.discount_type === PromoCodeType.Percentage ? withoutCurrency : this.promoCode;

    this.direct.updatePromoCode(promoCode).subscribe(
      (response) => {
        this.saving = false;
        this.recentlySaved = true;

        setTimeout(() => {
          this.recentlySaved = false;
        }, 3000);
      },
      (err) => {
        this.saving = false;
        this.recentlySaved = false;
      }
    );
  }

  onPropertiesChange(properties) {
    this.promoCode.properties = properties;
  }
}
